var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"win"},[_c('div',{staticClass:"win_title"},[_c('h3',[_vm._v("恭喜您获得")]),_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" 储值大礼 ")]),_c('img',{staticClass:"win_img",attrs:{"src":"/activity/turntable/img/win.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }